import { Directive, TemplateRef, ViewContainerRef, inject, OnInit } from '@angular/core';
import { ConfigService } from '@assist/shared/data';

@Directive({
  selector: '[findTheColleagueEnabled], [*findTheColleagueEnabled]',
  standalone: true,
})
export class FindTheColleagueEnabledDirective implements OnInit {
  private templateRef = inject<TemplateRef<unknown>>(TemplateRef<unknown>);
  private viewContainer = inject(ViewContainerRef);
  private configService = inject(ConfigService);

  ngOnInit() {
    if (
      this.configService.value.enableReservations &&
      this.configService.value.enableFindTheCollegue &&
      !this.configService.isGspace()
    ) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
